import { Ajax2 } from "@shared/Ajax";
import { Events } from "@shared/Events";
import Feature from "ol/Feature";


let selectedFeature: Feature = null;
export const VectorTileMouseInteraction = {

    onClick: (feature: Feature, e, n): void => {
        if (!feature) return;

        const fileUuid = feature.get('fileUuid');
        const fileName = feature.get('fileName');
        const data = feature.get('data');

        Ajax2({
            url: kuura.getContextPath() + '/api/1/model/' + fileUuid + '/structure/properties',
            contentType: 'json',
            method: 'GET',
            useToken: true,
            data: {
                structName: data.name
            }
        }).then(resp => {
            const props = handleStructure(resp.structures[0], {});
            const propData = {
                id: data.id,
                name: `${fileName}: ${data.name}`,
                props: props,
                isStructure: true,
            }

            Events.trigger('mapClickModel', propData);
        })



    },

    onMouseOver: (feature: Feature, e, n): void => {
        feature.set('SELECTED', true);
        selectedFeature = feature;

        const fileUuid = feature.get('fileUuid');

        Events.trigger(`${fileUuid}-essential-update`)
        Events.trigger(`${fileUuid}-detail-update`)
    },

    clear: () => {

        if (selectedFeature) {
            selectedFeature.set('SELECTED', false);
        }

        Events.trigger('changeLayer')
        selectedFeature = null;
    }
}


const handleStructure = (structure, props) => {
    if (structure.structures) {
        structure.structures.forEach(child => {
            const childProps = handleStructure(child, props)
            props = {...props, ...childProps}
        } )
    }

    if (structure.props) {
        props = {...props, ...structure.props}
    }

    return props;
}
